import { hasNotUrl } from '@/core/lib/form/validators/hasNotUrl';

export { hasNotUrl };
